<template>
  <div class="search-component">
    <div class="search-bar-wrapper">
      <input
        type="text"
        v-model="query"
        placeholder="Search..."
        class="search-bar"
      />
      <button @click="filterList" class="search-button">
        <img src="@/assets/search.svg" alt="Search" class="search-icon" />
      </button>
    </div>
    <ul class="results">
      <li v-for="(item, index) in filteredItems" :key="index">
        <router-link :to="{ name: `${item.name}` }" class="title">{{ item.title }}</router-link>
        <p>{{ item.desc }}</p>
      </li>
    </ul>
    <div class="results" v-show="showNoResults">
      No results found
    </div>
  </div>
</template>


<script>
import doc from '@/documents/blogs.js';

export default {
  props: {
    selectedLanguage: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      query: "", // User's search input
      doc: doc.bloglist, // Blog data
      filteredItems: [], // Holds filtered results
      showNoResults: false, // Indicates if "No results" should be displayed
    };
  },
  methods: {
    filterList() {
      if (!this.query.trim()) {
        this.filteredItems = [];
        this.showNoResults = false;
        return;
      }
      const items = this.doc[this.selectedLanguage] || [];
      this.filteredItems = items.filter((item) =>
        item.title.toLowerCase().includes(this.query.toLowerCase())
      );
      this.showNoResults = this.filteredItems.length === 0;
    },
    resetSearch() {
      this.query = "";
      this.filteredItems = [];
      this.showNoResults = false;
    },
  },
  beforeDestroy() {
    // Reset search when the component is destroyed
    this.resetSearch();
  },
};
</script>

<style lang="scss" scoped>
$--group-option-flex: 0 calc(1 / 5) * 100%!default;
.search-bar-wrapper {
  display: flex;
  align-items: center;
  width: 90%;
  gap: 5px;
}

.search-bar {
  flex-grow: 1;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 50px;
  color: #303030;
}

.search-button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  margin-left: 8px;
}

.search-icon {
  width: 24px;
  height: 24px;
}

.results {
  list-style-type: none !important;
  padding: 0;
  margin: 10px 0 0 0 !important;
  width: 90%;
  color: #303030;
  .title {
    font-size: 1.3rem;
    margin-bottom: 12px;
    cursor: pointer;
    color: #151515;
    font-weight: 600;
  }
  .title:hover {
    color: #1b3d76;
    text-decoration: underline;
  }
}

.results li {
  padding: 0;
  border-radius: 4px;
  margin-bottom: 5px;
  border-bottom: 1px solid #d9d9d9;
}

@media (max-width: 768px) {
  .results {
    .title {
      font-size: 1.2rem;
      padding-top: 10px;
    }
    p {
      font-size: 1rem !important;
    }
  }
}
</style>
